export default function CommitmentSection() {
  return (
    <section className="relative py-24 md:py-32 lg:py-40 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="w-full lg:w-2/5">
            <div className="relative w-full aspect-[3/4] max-w-sm mx-auto lg:max-w-none rounded-2xl overflow-hidden bg-accent-100/50">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-accent-200/50 flex items-center justify-center">
                  <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-accent-300/40 flex items-center justify-center">
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-accent-400/30"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <div className="mb-4">
              <span className="text-xs tracking-widest uppercase text-foreground-400" style={{ fontFamily: 'var(--font-label)' }}>
                (commitment)
              </span>
            </div>

            <h2 className="text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-10 md:mb-14" style={{ fontFamily: 'var(--font-heading)' }}>
              Built for
              <br />
              <span className="text-foreground-400">the long term</span>
            </h2>

            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-xl" style={{ fontFamily: 'var(--font-body)' }}>
              We emphasize continuous innovation, improvement of development workflows, and adoption of up-to-date engineering standards to deliver reliable and future-ready IT solutions. Our commitment to technical excellence means every project is approached with discipline, thoroughness, and a long-term perspective. We actively explore new technologies and evolve internal processes to maintain the highest standards of engineering quality.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}